module.exports = {
  first: "#7F5D80",
  firstLight: "#CFC0CF", //"#AF95B0",
  firstSuperLight: "#F4F0F4",
  firstDark: "#563E57",
  accent: "#FF6633",
  bright: "#ffffff",
  light: "#f3f3f3",
  middle: "#666666",
  dark: "#333333",
  superDark: "#111111"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js